import { render } from "./MentionsList.vue?vue&type=template&id=3e14dc03"
import script from "./MentionsList.vue?vue&type=script&lang=js"
export * from "./MentionsList.vue?vue&type=script&lang=js"
script.render = render

export default script